import { useEffect, useState, useCallback } from "react";
import * as junipService from "@services/junip";

export const useRating = (product, productGroup) => {
  const [rating, setRating] = useState(null);

  useEffect(() => {
    if (product && product.id) {
      getRating(product.id);
    }

    return () => setRating(null);
  }, [productGroup]);

  const getRating = useCallback(async (id) => {

    //TODO: add the numeric id as a property to the variant object  
    const resolveId = () => {
      const values = id.split('/');
      return values[values.length -1];
    }
    try {
      const junipProduct = await junipService.junipProduct(resolveId());
      if (junipProduct) {
        setRating({
          average: junipProduct.rating_average,
          count: junipProduct.rating_count,
        });
      }

      return null;
    } catch (error) {
      console.log("[fetch-Junip] Error", error);
    }
  }, []);

  return rating;
};
